export const FEATURES = {
  SSJ_UI_EXCHANGE_MAX_LIMIT: false,
};

export default {
  FEATURES,
};
